export enum MaintenanceWindowTypes {
  PATCH_MANAGEMENT = 0,
}

export enum MaintenanceWindowTypeAttributes {
  patchmanagement = MaintenanceWindowTypes.PATCH_MANAGEMENT,
}
